import './About.scss';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ContactUs from '../ContactUs';
import { SettingOptions, SettingsHeader } from '../Settings';
import { REACT_APP_PRIVACY_POLICY, REACT_APP_TERMS_AND_CONDITIONS } from '../../../processENV';
import AboutDetails from './AboutDetails';
import PrivacyPolicy from './PrivacyPolicy';
export default class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parentAboutStatus: true,
            activeTab: null,
        };
    }

    backToAbout = () => {
        this.setState({
            parentAboutStatus: true,
            activeTab: null,
        });
    };

    handleAbout = label => {
        this.setState({
            parentAboutStatus: false,
            activeTab: label,
        });
    };

    handleContactUs = label => {
        this.setState({
            parentAboutStatus: true,
            activeTab: label,
        });
    };

    handlePopupClose = () => {
        this.setState({
            parentAboutStatus: true,
            activeTab: null,
        });
    };

    render() {
        let { parentAboutStatus, activeTab } = this.state;
        const { handleBackToSetting } = this.props;
        const openLink = url => {
            window.open(url, '_blank', 'noopener,noreferrer');
        };
        return (
            <Fragment>
                {parentAboutStatus && (
                    <div className="setting-container">
                        <div>
                            <div className="settinglist">
                                <SettingsHeader
                                    handleBackFromSetting={handleBackToSetting}
                                    label={'Terms & Policies'}
                                />
                                <ul className="setting-list-ul About">
                                    {/* <SettingOptions
                                        image={'about'}
                                        label={'About Us'}
                                        handleOptions={this.handleAbout}
                                    /> */}
                                    {/* <SettingOptions
                                        image={'contactUs'}
                                        label={'Contact Us'}
                                        enableRightArrow={false}
                                        handleOptions={this.handleContactUs}
                                    />
                                    <SettingOptions
                                        image={'policy'}
                                        enableRightArrow={false}
                                        handleOptions={() => { }}
                                        label={'Terms and Privacy Policy'}
                                    >
                                        <div className='setting_privacy_content'>
                                            <div className='setting_privacy_link'>
                                                <a href={REACT_APP_TERMS_AND_CONDITIONS} target="_blank" rel="noopener noreferrer">Terms and Conditions,</a>
                                                <a href={REACT_APP_PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">Privacy Policy.</a>
                                            </div>
                                        </div> */}
                                    {/* </SettingOptions> */}
                                    {/* Terms & Conditions */}
                                    <SettingOptions
                                        image={'about'}
                                        label={'Terms & conditions'}
                                        handleOptions={() => openLink(REACT_APP_TERMS_AND_CONDITIONS)}
                                    />

                                    {/* Privacy Policy */}
                                    <SettingOptions
                                        image={'policy'}
                                        label={'Privacy Policy'}
                                        handleOptions={() => openLink(REACT_APP_PRIVACY_POLICY)}
                                    />
                                </ul>
                            </div>
                        </div>
                    </div>
                )}
                {!parentAboutStatus && (
                    <Fragment>
                        {activeTab === 'about' && <AboutDetails backToAbout={this.backToAbout} />}
                        {activeTab === 'policy' && <PrivacyPolicy backToAbout={this.backToAbout} />}
                    </Fragment>
                )}
                {activeTab === 'contactUs' && <ContactUs handlePopupClose={this.handlePopupClose} />}
            </Fragment>
        );
    }
}

About.propTypes = {
    handleBackToSetting: PropTypes.func,
};
